import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import inboundEmailKeys from './keyFactory';

const GetInboundEmailAddresses = graphql(`
  query InboundEmailAddresses {
    me {
      inboundEmailAddresses {
        forwardAddress
        copyAddress
      }
    }
  }
`);

const useGetMyInboundEmailAddresses = () => {
  return useQuery({
    queryKey: inboundEmailKeys.addresses(),
    queryFn: () => {
      return gqlClient.request(GetInboundEmailAddresses);
    },
  });
};

export default useGetMyInboundEmailAddresses;
